'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface FeaturesCTABannerProps {
  postSlug: string;
  postTitle: string;
  isAuthenticated: boolean;
}

export function FeaturesCTABanner({
  postSlug,
  postTitle,
  isAuthenticated,
}: FeaturesCTABannerProps) {
  const analytics = useAnalytics();

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      postTitle,
      ctaType: 'features',
      ctaLabel: 'Coba Gratis 24 Jam',
      isAuthenticated,
    });
  };

  return (
    <section className="relative px-4 py-6 md:px-8 md:py-8 lg:px-12 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="md:max-w-[450px] md:mx-auto">
          <Link href="/features" className="block group" onClick={handleClick}>
            <div className="bg-white border-2 border-black overflow-hidden transition-all duration-300 group-hover:-translate-y-0.5">
              <div className="p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-2xl md:text-3xl font-bold text-black mb-3 leading-tight uppercase font-sans tracking-tight">
                  Ingin Analisis
                  <br />
                  Lebih Dalam?
                </h3>

                <p className="text-gray-700 font-medium mb-6">
                  Konsolidasi peraturan, agen riset AI, dan pemetaan relasi antar aturan — coba gratis 24 jam tanpa kewajiban berlangganan.
                </p>

                <div className="inline-flex items-center justify-center gap-2 bg-neutral-900 text-white px-6 py-3 font-bold text-sm md:text-base hover:bg-neutral-800 transition-colors w-fit">
                  Coba Gratis 24 Jam
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}
